import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { UserListFacade } from './user-list.facade';

@Injectable({
  providedIn: 'root',
})
export class UserListGuard  {
  constructor(private userListFacade: UserListFacade) {}

  canActivate(): Observable<boolean> {
    return loadStoreState(this.userListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.userListFacade);
  }
}
